import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

const ContentfulImage = ({
  imageFragment,
  gatsbyImageData = imageFragment?.gatsbyImageData,
  className,
  lazy,
  placeholder = 'blurred',
  useObject = false,
  max700 = false,
  ...rest
}) => {
  if (!imageFragment) return null;
  const isSvg = imageFragment.file?.contentType === 'image/svg+xml';
  if (isSvg)
    if (useObject)
      return (
        <div>
          <object
            aria-label={imageFragment.description || imageFragment.alt || rest?.alt || 'visual'}
            data={imageFragment.file.url}
            type="image/svg+xml"
            className={className}
            alt={imageFragment.description || imageFragment.alt || rest?.alt}
            {...rest}
          />
        </div>
      );
    else
      return (
        <img
          loading={lazy ? 'lazy' : 'eager'}
          src={imageFragment.file.url}
          alt={imageFragment.description || imageFragment.alt || imageFragment.title}
          className={className}
          width={imageFragment.width}
          height={imageFragment.height}
          {...rest}
        />
      );
  if (typeof window !== 'undefined' && imageFragment.fullWidth > window.innerWidth)
    return (
      <GatsbyImage
        data-ot-ignore={true}
        loading={lazy ? 'lazy' : 'eager'}
        alt={imageFragment.description || imageFragment.alt || imageFragment.title || ''}
        image={max700 ? imageFragment.max700 : gatsbyImageData}
        className={className}
        fullWidth
        placeholder={placeholder}
        width={imageFragment.width}
        height={imageFragment.height}
        {...rest}
      />
    );
  return (
    <GatsbyImage
      loading={lazy ? 'lazy' : 'eager'}
      data-ot-ignore
      alt={imageFragment.description || imageFragment.alt || imageFragment.title || ''}
      image={max700 ? imageFragment.max700 : gatsbyImageData}
      className={className}
      constrained={'true'}
      width={imageFragment.width}
      height={imageFragment.height}
      {...rest}
    />
  );
};

ContentfulImage.propTypes = {
  /** The ContentfulAsset object **/
  imageFragment: PropTypes.object.isRequired,
  /** The specific version of gatsbyImageData to use (when dealing with aliases) **/
  gatsbyImageData: PropTypes.object,
  /** Optional classname to be added to the top level tag **/
  className: PropTypes.string,
};

export default ContentfulImage;
